import { render } from "./ExpensesDropDown.vue?vue&type=template&id=6ffa71c4&scoped=true"
import script from "./ExpensesDropDown.vue?vue&type=script&lang=js"
export * from "./ExpensesDropDown.vue?vue&type=script&lang=js"

import "./ExpensesDropDown.vue?vue&type=style&index=0&id=6ffa71c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffa71c4"]])

export default __exports__